import SignUpEmployee from './Employee/EmployeeView';
import SignUpEmployeeStep1 from './Employee/SignUpEmployeeStep1/SignUpEmployeeStep1View';
import SignUpEmployeeStep2 from './Employee/SignUpEmployeeStep2/SignUpEmployeeStep2View';
import SignUpEmployeeStep3 from './Employee/SignUpEmployeeStep3/SignUpEmployeeStep3View';
import SignUpEmployeeStep4 from './Employee/SignUpEmployeeStep4/SignUpEmployeeStep4View';

// Company Signup
import SignUpCompany from './Company';
import SignUpCompanyStep1 from './Company/SignUpCompanyStep1';
import SignUpCompanyStep2 from './Company/SignUpCompanyStep2';
import SignUpCompanyStep3 from './Company/SignUpCompanyStep3';

import SignUpView from './SignUpView';

export const SignUp = [
  {
    path: '/:invitationToken/:invitationUuid/confirm-invitation-employee',
    redirect: (to) => {
      const { invitationToken, invitationUuid } = to.params;
      return `/signup/user/${invitationToken}/${invitationUuid}/step1`;
    },
  },
  {
    path: '/signup',
    name: 'SignUpView',
    component: SignUpView,
    children: [
      {
        path: 'user',
        name: 'SignUp_User',
        component: SignUpEmployee,
        children: [
          {
            path: ':invitationToken/:invitationUuid/step1',
            name: 'SignUp_User_Invitation-Step-1',
            component: SignUpEmployeeStep1,
          },
          {
            path: ':invitationToken/:invitationUuid/step2',
            name: 'SignUp_User_Invitation-Step-2',
            component: SignUpEmployeeStep2,
          },
          {
            path: ':invitationToken/:invitationUuid/step3',
            name: 'SignUp_User_Invitation-Step-3',
            component: SignUpEmployeeStep3,
          },
          {
            path: ':invitationToken/:invitationUuid/step4',
            name: 'SignUp_User_Invitation-Step-4',
            component: SignUpEmployeeStep4,
          },
          {
            path: 'step1',
            name: 'SignUp_User_Step-1',
            component: SignUpEmployeeStep1,
          },
          {
            path: 'step2',
            name: 'SignUp_User_Step-2',
            component: SignUpEmployeeStep2,
          },
          {
            path: 'step3',
            name: 'SignUp_User_Step-3',
            component: SignUpEmployeeStep3,
          },
          {
            path: 'step4',
            name: 'SignUp_User_Step-4',
            component: SignUpEmployeeStep4,
          },
        ],
      },
      {
        path: 'company',
        name: 'SignUp_Company',
        component: SignUpCompany,
        children: [
          {
            path: 'step1',
            name: 'SignUp_Company-Step-1',
            component: SignUpCompanyStep1,
          },
          {
            path: 'step2',
            name: 'SignUp_Company-Step-2',
            component: SignUpCompanyStep2,
          },
          {
            path: 'step3',
            name: 'SignUp_Company-Step-3',
            component: SignUpCompanyStep3,
          },
        ],
      },
    ],
  },
];

export default SignUp;
